/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Totaldealsize3Inputs */

const en_coinvestments_totaldealsize3 = /** @type {(inputs: Coinvestments_Totaldealsize3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Deal Size`)
};

/**
* | output |
* | --- |
* | "Total Deal Size" |
*
* @param {Coinvestments_Totaldealsize3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_totaldealsize3 = /** @type {((inputs?: Coinvestments_Totaldealsize3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Totaldealsize3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_totaldealsize3(inputs)
});
export { coinvestments_totaldealsize3 as "coInvestments_totalDealSize" }